import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from "react-redux";
// import ManMeditate from "assets/images/icons/project-icons/Man-meditate.gif";
import TimeRectangle from "assets/images/icons/project-icons/Time_Rectangle.gif";
import OnboardingTitle from 'components/__new/common/onboardingTitle';
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";


class GetStartedDemo extends Component {

    state = {}


    render() { 
        return (
            <React.Fragment>

                <DynamicHeadTag headerText="Onboarding" />

                <div className="lg:flex">
                    <div className="w-full lg:w-1/2">
                        <div className="page-title">
                            Dashboard
                        </div>
                    </div>
                    <div className="w-full flex mt-2 lg:mt-0 lg:justify-end space-x-3 lg:w-1/2"></div>
                </div>
                
                <div className="mt-6 box">
                    <OnboardingTitle tab="financials" />
                </div>

                <div className="mt-2 box">
                    <div className="max-w-md mx-auto mt-4 mb-8">
                       <div>
                        <div className="h-64 flex">
                                <img src={TimeRectangle} alt="Thank You" className="m-auto h-full object-contain" />
                            </div>
                            <div className="text-center font-semibold text-2xl sm:text-3xl text-ep-primary">
                                Please wait while we approve your account
                            </div>
                            <div className="mt-3 text-center">
                                This usually takes up to 3 working days
                            </div>
                            <div className="mt-8">
                                <Link to="/get-started/info/general?preview" className="btn btn-lg btn-ep-primary btn-block">
                                    Edit Registration Details
                                </Link>
                            </div>
                       </div>
                    </div>
                </div>

            </React.Fragment>

        );
    }
}
 

const mapStateToProps = (state) => ({
    user: state.auth.userPersist.data,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(GetStartedDemo);